module.exports = __webpack_public_path__ + "static/img/159_TO8_1886_og.32fa0f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/159_TO8_1886_og.jpg
// module id = qcAV
// module chunks = 0